import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { ClientStatus } from '../../types/clients';

interface ChangeClientStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (status: ClientStatus) => void;
  currentStatus: ClientStatus;
  loading?: boolean;
}

const ChangeClientStatusModal: React.FC<ChangeClientStatusModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  currentStatus,
  loading = false
}) => {
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState<ClientStatus>(currentStatus);

  useEffect(() => {
    if (isOpen) {
      setSelectedStatus(currentStatus);
    }
  }, [isOpen, currentStatus]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(selectedStatus);
  };

  const handleClose = () => {
    setSelectedStatus(currentStatus);
    onClose();
  };

  const isFormValid = () => {
    return selectedStatus !== currentStatus;
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.changeClientStatus.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        <div className="modal-form-group">
          <label htmlFor="status">{t('modals.changeClientStatus.selectStatus')}</label>
          <select
            id="status"
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value as ClientStatus)}
            required
            disabled={loading}
          >
            <option value={ClientStatus.ACTIVE}>{t('modals.changeClientStatus.active')}</option>
            <option value={ClientStatus.BLOCKED}>{t('modals.changeClientStatus.blocked')}</option>
          </select>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.changeClientStatus.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button primary"
            disabled={loading || !isFormValid()}
          >
            {loading ? t('modals.changeClientStatus.changing') : t('modals.changeClientStatus.change')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ChangeClientStatusModal;
